/* ============================================================
   HOME · BRANDS AUTHORITY WALL (Athlete Endorsement)
   Tilt 3D + spotlight (desktop/pointer fino), parallax del atleta
   (scroll + mouse), stagger reveal, contadores animados, ripple.
   Vanilla, rAF, respeta prefers-reduced-motion. Solo transform/opacity.
   ============================================================ */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(min-width: 1024px) and (pointer: fine)').matches;
  var desktop = window.matchMedia('(min-width: 1024px)').matches;

  function initCard(card) {
    if (!fine || reduce) return;
    var rx = 0, ry = 0, tx = 0, ty = 0, raf = null, rect = null, MAX = 9;
    function enter() { rect = card.getBoundingClientRect(); }
    function move(e) {
      if (!rect) rect = card.getBoundingClientRect();
      var px = (e.clientX - rect.left) / rect.width;
      var py = (e.clientY - rect.top) / rect.height;
      px = px < 0 ? 0 : px > 1 ? 1 : px;
      py = py < 0 ? 0 : py > 1 ? 1 : py;
      tx = (py - 0.5) * -2 * MAX;
      ty = (px - 0.5) * 2 * MAX;
      card.style.setProperty('--mx', (px * 100).toFixed(1) + '%');
      card.style.setProperty('--my', (py * 100).toFixed(1) + '%');
      if (!raf) raf = requestAnimationFrame(loop);
    }
    function loop() {
      rx += (tx - rx) * 0.15;
      ry += (ty - ry) * 0.15;
      card.style.setProperty('--rx', rx.toFixed(2) + 'deg');
      card.style.setProperty('--ry', ry.toFixed(2) + 'deg');
      if (Math.abs(tx - rx) > 0.04 || Math.abs(ty - ry) > 0.04) { raf = requestAnimationFrame(loop); } else { raf = null; }
    }
    function leave() { tx = 0; ty = 0; rect = null; if (!raf) raf = requestAnimationFrame(loop); }
    card.addEventListener('pointerenter', enter);
    card.addEventListener('pointermove', move);
    card.addEventListener('pointerleave', leave);
  }

  function animateCount(el) {
    var target = parseInt(el.getAttribute('data-target'), 10) || 0;
    var pad = el.getAttribute('data-pad') === '1';
    function fmt(n) { return (pad && n < 10) ? ('0' + n) : ('' + n); }
    if (reduce) { el.textContent = fmt(target); return; }
    var dur = 1300, start = null;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var e = 1 - Math.pow(1 - p, 3);
      el.textContent = fmt(Math.floor(e * target));
      if (p < 1) { requestAnimationFrame(step); } else { el.textContent = fmt(target); }
    }
    requestAnimationFrame(step);
  }

  function initParallax(root) {
    var wrap = root.querySelector('[data-hba-parallax]');
    if (!wrap || reduce || !desktop) return;
    var sy = 0, mx = 0, my = 0, raf = null;
    function onScroll() { if (!raf) raf = requestAnimationFrame(update); }
    function update() {
      raf = null;
      var r = root.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var center = r.top + r.height / 2;
      var prog = (center - vh / 2) / (vh / 2 + r.height / 2);
      prog = prog < -1 ? -1 : prog > 1 ? 1 : prog;
      sy = -prog * 30;
      apply();
    }
    function onMove(e) {
      var r = root.getBoundingClientRect();
      mx = ((e.clientX - r.left) / r.width - 0.5) * 16;
      my = ((e.clientY - r.top) / r.height - 0.5) * 12;
      apply();
    }
    function apply() { wrap.style.transform = 'translate3d(' + mx.toFixed(1) + 'px,' + (sy + my).toFixed(1) + 'px,0)'; }
    window.addEventListener('scroll', onScroll, { passive: true });
    root.addEventListener('pointermove', onMove);
    update();
  }

  function attachRipple(el) {
    el.addEventListener('click', function (e) {
      if (reduce) return;
      var r = el.getBoundingClientRect();
      var d = Math.max(r.width, r.height);
      var s = document.createElement('span');
      s.className = 'hba-ripple';
      s.style.width = d + 'px';
      s.style.height = d + 'px';
      s.style.left = (e.clientX - r.left - d / 2) + 'px';
      s.style.top = (e.clientY - r.top - d / 2) + 'px';
      el.appendChild(s);
      setTimeout(function () { if (s.parentNode) s.parentNode.removeChild(s); }, 600);
    });
  }

  function initSection(root) {
    if (!root || root.__hbaInit) return;
    root.__hbaInit = true;
    if (!reduce) root.classList.add('hba--animate');

    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-hba-card]'));
    cards.forEach(initCard);
    initParallax(root);
    root.querySelectorAll('[data-hba-ripple]').forEach(attachRipple);

    var counters = Array.prototype.slice.call(root.querySelectorAll('[data-hba-count]'));

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es, obs) {
        es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); obs.unobserve(en.target); } });
      }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
      cards.forEach(function (c) { io.observe(c); });
      root.__hbaIO = io;

      if (counters.length) {
        var cio = new IntersectionObserver(function (es, obs) {
          es.forEach(function (en) { if (en.isIntersecting) { animateCount(en.target); obs.unobserve(en.target); } });
        }, { threshold: 0.5 });
        counters.forEach(function (c) { cio.observe(c); });
      }
    } else {
      cards.forEach(function (c) { c.classList.add('is-in'); });
      counters.forEach(animateCount);
    }
  }

  function initAll() { document.querySelectorAll('[data-hba]').forEach(initSection); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', initAll); } else { initAll(); }
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-hba]') || (e.target.matches && e.target.matches('[data-hba]') ? e.target : null);
    if (root) initSection(root);
  });
})();
